import { FlexContainer, TaggableChip } from '@act/storybook';

export interface DialogTitleWithRecoveredNoteProps {
  /** Dialog title text (typically includes the member name). */
  title: string;
  /** When true, shows a recovered-note tag beside the title. */
  showRecoveredNote?: boolean;
}

/**
 * Dialog header title row with an optional recovered-note tag beside it.
 * @param props Title text and recovered-note visibility.
 * @returns Title content for CompositeDialog or similar headers.
 */
export const DialogTitleWithRecoveredNote = ({
  title,
  showRecoveredNote = false,
}: DialogTitleWithRecoveredNoteProps) => (
  <FlexContainer
    direction="row"
    alignItems="center"
    gap={2}
    width="auto"
    height="auto"
  >
    <span>{title}</span>
    {showRecoveredNote && (
      <TaggableChip
        isTag
        color="neutral"
        label="Recovered note"
        variant="outlined"
      />
    )}
  </FlexContainer>
);
